import apiHeader from '@/helpers/apiHeader';

const advanceSearchService = {
    search(params) {
        const { page, per_page, ...payload } = params;
        return apiHeader.post('navbar/advance-search-material/search', payload, {
            params: { page, per_page }
        });
    },
    
    getMaterialDetail(materialNumber) {
        return apiHeader.get(`navbar/advance-search-material/${materialNumber}`);
    }
}

export default advanceSearchService;